/* Right-pane module editor: header (title + coverage badge) + tab switcher. */
import { useState } from "react";
import { heatClass, heatColor } from "./coverage";
import { LessonsTab } from "./LessonsTab";
import { QuestionsTab } from "./QuestionsTab";
import { MetadataTab } from "./MetadataTab";

export function ModuleEditor({ module, counts, courseModules = [], onChange }) {
  const [tab, setTab] = useState("lessons");
  const target = counts?.bank_target || 0;
  const real = counts?.real_exam_questions || 0;
  const pct = counts?.coverage_pct || 0;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
        <div>
          <div className="tbg-section-sub">Module {module.code}{module.is_bonus && " · Bonus"}</div>
          <h1 className="tbg-section-title">{module.title}</h1>
          {module.summary && (
            <p style={{ color: "#a5b8b3", fontSize: 12, marginTop: 6, lineHeight: 1.55, maxWidth: 640 }}>{module.summary}</p>
          )}
        </div>
        {!module.is_bonus && target > 0 && (
          <div style={{ minWidth: 200, textAlign: "right" }} data-testid="authoring-module-coverage">
            <div style={{ font: "700 10px 'JetBrains Mono', monospace", letterSpacing: "0.16em",
              color: "#7b8b87", textTransform: "uppercase" }}>Coverage</div>
            <div style={{ font: "800 22px 'Montserrat','Geist','Inter'", color: heatColor(pct), lineHeight: 1 }}>
              {pct}%
            </div>
            <div style={{ font: "500 11px 'JetBrains Mono', monospace", color: "#7b8b87" }}>
              {real} / {target} real · {module.est_hours}h weight
            </div>
            <div className="tbg-heat-bar" style={{ marginTop: 6, width: 180, marginLeft: "auto" }}>
              <span className={heatClass(pct)} style={{ width: `${Math.min(100, pct)}%` }} />
            </div>
          </div>
        )}
      </div>

      <div style={{ display: "flex", gap: 4, marginTop: 20, borderBottom: "1px solid #1c2a27" }}>
        {["lessons", "questions", "metadata"].map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            data-testid={`authoring-tab-${t}`}
            style={{
              padding: "10px 14px", background: "transparent", border: 0, cursor: "pointer",
              borderBottom: tab === t ? "2px solid #3dc0af" : "2px solid transparent",
              color: tab === t ? "#3dc0af" : "#7b8b87",
              font: "700 10px 'JetBrains Mono', monospace", letterSpacing: "0.2em", textTransform: "uppercase",
            }}
          >
            {t}
          </button>
        ))}
      </div>

      <div style={{ marginTop: 20 }}>
        {tab === "lessons" && <LessonsTab module={module} onChange={onChange} />}
        {tab === "questions" && <QuestionsTab module={module} courseModules={courseModules} onChange={onChange} />}
        {tab === "metadata" && <MetadataTab module={module} onChange={onChange} />}
      </div>
    </div>
  );
}
